<template>
  <div class="my-item">
    <div class="custom-wrap">
      <template v-if="list && list.length">
        <Table :border="false" :columns="columns1" :data="list" :disabled-hover="false">
          <template slot-scope="{ row, index }" slot="name">
            <span class="brand">{{row.name}}</span>
          </template>
          <template slot-scope="{ row, index }" slot="nameEn">{{row.nameEn}}</template>
          <template slot-scope="{ row, index }" slot="showIndex">{{row.showIndex}}</template>
          <template slot-scope="{ row, index }" slot="action">
            <span style="color: #1890ff;cursor: pointer;" @click="editShow(row)">编辑</span>
            <span style="display: inline-block;padding: 0 5px;">|</span>
            <Poptip confirm title="确认是否删除?" @on-ok="delItem(row)" :transfer="true">
              <span style="color: #f00;cursor: pointer;">删除</span>
            </Poptip>
          </template>
        </Table>
      </template>
      <div class="u-empty" v-else>暂无数据</div>
    </div>
    <supplyAdd 
      :show="show" 
      @finish="init()" 
      @close="show=false;"
    />
    <supplyEdit 
      :show="edit" 
      @finish="init()" 
      v-if="editInfo"
      :editInfo="editInfo"
      @close="edit=false;editInfo=null"
    />
  </div>
</template>

<script>
import supplyAdd from "../components/supply-add.vue";
import supplyEdit from "../components/supply-edit.vue";
import { mapActions } from "vuex";

export default {
  // 主办设置
  name: "host-set",
  data() {
    return {
      list: null, 
      edit: false,
      editInfo: false,
      show: false,  
      columns1: [
        {
          title: "供需类别",
          slot: "name",
          key: "name",
          align: "center"
        },
        {
          title: "英文供需类别",
          slot: "nameEn",
          key: "nameEn",
          align: "center"
        },
        {
          title: "排序",
          slot: "showIndex",
          key: "showIndex",
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          align: "center"
        }
      ]
    };
  },
  computed: {
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    }
  },
  created() {
    this.init();
  },
  components: {
    supplyAdd, 
    supplyEdit, 
  },
  methods: {
    ...mapActions({
      getReleaseType: "momentModule/getReleaseType", 
      delReleaseType: "momentModule/delReleaseType", 
      editReleaseType: "momentModule/editReleaseType", 
      addRelease: "momentModule/addRelease", 
    }),  
    async init() {
      let listData = await this.getReleaseType(this.exhibitionInfo.id); 
      if (listData && listData.length) {
        this.list = listData;
      }
    }, 
    async delItem(item) { 
      let result = await this.delReleaseType(item.id);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },
    showAdd() {
      this.show = true;
    },
    editShow(e) {
      this.edit = false;
      this.editInfo = e;
    }
  }
};
</script>

<style scoped lang="scss">
.custom-wrap {
  margin: 0 auto;
  min-height: 500px;
} 
</style>
